"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FACET_FILTER_CATEGORY = void 0;
const FACET_FILTER_CATEGORY = exports.FACET_FILTER_CATEGORY = 'facet-filter-category';
